// Generated by purs version 0.15.10
import * as Effect_Exception_Unsafe from "../Effect.Exception.Unsafe/index.js";
var unimplemented = function () {
    return function (v) {
        return Effect_Exception_Unsafe.unsafeThrow("Unimplemented!");
    };
};
export {
    unimplemented
};
